import MultiLinkedBookkeepingList from "components/Picker/Bookkeeping/MultiLinkedBookkeepingList";
import { ModalForMultiPicker } from "components/Picker/ModalForMultiPicker";
import React from "react";
import { LinkedBookkeepingsPanel } from "./LinkedBookkeepingsPanel";

interface Props {
  userToClientId: number;
}

export const LinkedBookkeepingsUserPanel = (props: Props) => {
  const [isNewModalOpen, setIsNewModalOpen] = React.useState(false);
  const [queryKeyIncrement, setQueryKeyIncrement] = React.useState(0);

  const onAddBookkeepings = async (newBookkeepings: server.dto.BookkeepingSmall[]) => {
    await window.CoreApi.UserForInternalAdmin.LinkBookkeepings({
      userToClientId: props.userToClientId,
      bookkeepingIds: newBookkeepings.map(bk => bk.bookkeepingId),
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
    setIsNewModalOpen(false);
  }

  const unlinkBookkeeping = async (bookkeeping: server.dto.BookkeepingSmall) => {
    await window.CoreApi.UserForInternalAdmin.UnlinkBookkeepings({
      userToClientId: props.userToClientId,
      bookkeepingIds: [bookkeeping.bookkeepingId],
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
  }

  return <>
    <LinkedBookkeepingsPanel<server.dto.PaginatedUserToClientToBookkeepingLinkedBookkeepingsInstruction>
      queryKey={queryKeyIncrement.toString()}
      perPage={8}
      title={RESX.SoUser.AccessToBookKeepings}
      noSelectionLabel={RESX.Bookkeeping.AssignAtLeastOneBookkeeping}
      listFunc={window.CoreApi.UserForInternalAdmin.PaginatedLinkedBookkeepings}
      initialInstruction={{
        userToClientId: props.userToClientId,
        whereInOrNotIn: "in",
        keyword: "",
        page: 1,
        perPage: 8,
      }}
      onDelete={unlinkBookkeeping}
      onAdd={() => setIsNewModalOpen(true)}
      onRemoveAll={() => window.CoreApi.UserForInternalAdmin.UnlinkAllForUserToClient({
        userToClientId: props.userToClientId,
      })}
      onAddAll={() => window.CoreApi.UserForInternalAdmin.LinkAllForUserToClient({
        userToClientId: props.userToClientId,
      })}
    />

    {isNewModalOpen && <ModalForMultiPicker
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={RESX.Bookkeeping.Bookkeepings}
      modalSize="small"
      onClose={() => setIsNewModalOpen(false)}
      onSave={onAddBookkeepings}
      initialValue={[]}
      renderModalContent={(editedValue, setEditedValue) => <MultiLinkedBookkeepingList
        initialInstruction={{
          userToClientId: props.userToClientId,
          whereInOrNotIn: "notIn",
          keyword: "",
          page: 1,
          perPage: 20,
        }}
        listFunc={window.CoreApi.UserForInternalAdmin.PaginatedLinkedBookkeepings}
        onChange={setEditedValue}
        value={editedValue}
      />}
    />}
  </>
};